import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  open: false,
  payload: null,
};

const setModalLoginLogout = (state, action) => {
  return updateObject(state, { open: true, payload: action.payload });
};

const removeModal = (state, action) => {
  return updateObject(state, { open: false, payload: null });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_MODAL_LOGIN_LOGOUT:
      return setModalLoginLogout(state, action);
    case actionTypes.REMOVE_MODAL:
      return removeModal(state, action);
    default:
      return state;
  }
};

export default reducer;
